import Promotion26UpCContainer from "@/containers/Promotion/Promotion26UpCContainer";

export default function Promotion26UpCPage() {
  return <Promotion26UpCContainer />;
}
